import { render } from "./WithdrawConfirmModal.vue?vue&type=template&id=f43f6abc&scoped=true"
import script from "./WithdrawConfirmModal.vue?vue&type=script&lang=js"
export * from "./WithdrawConfirmModal.vue?vue&type=script&lang=js"

import "./WithdrawConfirmModal.vue?vue&type=style&index=0&id=f43f6abc&lang=scss&scoped=true"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f43f6abc"]])

export default __exports__